import { FC } from 'react'
import { TrophyCard } from '~/components/TrophyCard/TrophyCard'
import styles from './TrophyGallery.module.scss'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'

interface Props {
  trophies: ComponentTrophyDto[]
}
export const TrophyGallery: FC<Props> = ({ trophies }) => {
  return (
    <div className={ styles.trophyGallery__container }>
      {
        trophies.map((trophy) => (
          <TrophyCard
            trophyDto={ trophy }
            key={ trophy.id }
          />
        ))
      }
    </div>
  )
}
